<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="titulaire?.personneMorale"
    [label]="step5.getpersonnemorale" [type]="'text'" [rule]="required" [errorMessage]="errorMessagePersonneMoral" [name]="getUid() + '_SepAtt_personneMorale'">
</app-form-input>
<fieldset>
    <legend>
        {{ step5.getspan7 | translate }}
    </legend>
    <app-type-pers [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
        [correspondantPRM]="titulaire?.personnePhysique" [rule]="required + '|'">
    </app-type-pers>
</fieldset>
<fieldset>
    <legend>
        {{ step5.getspan8 | translate }}
    </legend>
    <app-type-adresse [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [adr]="titulaire?.adr" [rule]="required + '|'">
    </app-type-adresse>
    <app-type-coord [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [coord]="titulaire?.coord" [rule]="required + '|'">
    </app-type-coord>
</fieldset>
